import { useContext } from 'react';

import { BaseModalContext, type BaseModalType } from '@admin/organisms/BaseModal/BaseModalProvider';
import { type ArticleBlockType } from '@common/clients/api';

export const useModalContext = (contextKey: BaseModalType | ArticleBlockType | string) => {
    const { state, openModal, closeModal } = useContext(BaseModalContext);

    const handleOpenModal = () => (openModal ? openModal(contextKey) : undefined);
    const handleCloseModal = () => (closeModal ? closeModal(contextKey) : undefined);

    return { state: state[contextKey], openModal: handleOpenModal, closeModal: handleCloseModal };
};
